<template>
  <enfold>
    <enfold-uc>
      <template slot="up">
        <div class="c-u-left flex-b-c">
          <el-button size="mini" round type="primary" @click="$router.go(-1)">{{ $t('nstm59') }}</el-button>
          <el-button size="mini" round type="primary" @click="dialogVisible = true">{{ $t('cscn1') }}</el-button>
        </div>
        <div class="c-u-right">

        </div>
      </template>
      <template slot="center">
        <div id="google-map-container" style="width: 100%;height: 100%;"></div>
      </template>
    </enfold-uc>
    <el-dialog :title="$t('nstm60')" :visible.sync="outerVisible" top="0vh" width="400px">
      <play-list :innerVisible="innerVisible" @closeDialog="closeDialog"></play-list>
      <div class="point-set" v-if="point">
        <div class="play flex-b-c">
          <span> {{ $t('nstm62') }}: </span>
          <span style="cursor: pointer;" @click="innerVisible = true">
            {{ point.playInfo ? point.playInfo.name : $t('nstm63') }} <i class="el-icon-arrow-right"></i>
          </span>
        </div>
        <div class="flex-b-c">
          <span> {{ $t('cbpl01') }}: </span>
          <set-radius @setRadiusSize="setRadiusSize" :defaultSize="point.radius"></set-radius>
        </div>
        <div>
          <span>{{ point.title || "" }}</span>
          <br />
          <span>{{ point.lnglat || "" }}</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addPointSet(false)">{{ $t('cdce7') }}</el-button>
        <el-button @click="addPointSet(true)" type="primary">{{ $t('cdce6') }}</el-button>
      </div>
    </el-dialog>
    <msg-dialog :dialogVisible="dialogVisible" @closeDialog="closePointName" :title="$t('nstm64')">
      <div class="flex-b-c">
        <div style="width: 100px">{{ $t('ctce2') }}:</div><el-input v-model="pointName" :placeholder="$t('nstm35')"
          size="small"></el-input>
      </div>
    </msg-dialog>
  </enfold>
</template>

<script>
// eslint-disable-next-line
/* global google */
import EnfoldUc from "@/components/basics/EnfoldUC"
import Enfold from "@/components/basics/Enfold"
import MsgDialog from "@/components/basics/MsgDialog";
import PlayList from "@/components/basics/PlayList"
import SetRadius from './SetRadius';

export default {
  name: "AddGooglePoint",
  components: {
    EnfoldUc,
    Enfold,
    PlayList,
    SetRadius,
    MsgDialog
  },
  data() {
    return {
      pointList: [],
      outerVisible: false,
      innerVisible: false,
      dialogVisible: false,
      pointName: "",
      point: null,
      map: null,
      mapLoaded: false
    }
  },
  mounted() {
    this.loadGoogleMaps();
  },
  methods: {
    loadGoogleMaps() {
      // 动态加载谷歌地图API
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCkbvahjHlJ7-8xcbbjEQF8ZuH01CNrrLw&libraries=places&callback=initGoogleMap`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);

      // 设置全局回调函数
      window.initGoogleMap = () => {
        this.mapLoaded = true;
        this.initMap();
      };
    },

    initMap() {
      // 初始化地图
      let defaultCenter = { lat: 40.7167, lng: -74.0059 };
      if (process.env.VUE_APP_INDIA === 'true') {
        defaultCenter = { lat: 28.668825279039027, lng: 77.50473637586946 };
      }

      this.map = new google.maps.Map(document.getElementById('google-map-container'), {
        center: defaultCenter,
        zoom: 10,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      });

      // 添加地图点击事件
      this.map.addListener('click', async (e) => {
        const lng = e.latLng.lng();
        const lat = e.latLng.lat();

        let address = this.$t('nstm61');
        try {
          address = await this.geocoder(lng, lat);
        } catch (error) {
          console.error('获取地址失败:', error);
        }

        this.point = { lnglat: [lng, lat], title: address, radius: 2, playInfo: null };
        this.outerVisible = true;
      });

      // 初始化已有点位
      this.initMarker();
    },

    geocoder(lon, lat) {
      return new Promise((resolve, reject) => {
        if (!window.google) {
          reject(this.$t("nstm65"));
          return;
        }

        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ location: { lat: lat, lng: lon } }, (results, status) => {
          if (status === google.maps.GeocoderStatus.OK && results[0]) {
            const address = results[0].formatted_address;
            resolve(address);
          } else {
            reject(this.$t("nstm65"));
            console.error('获取地址失败:', status);
          }
        });
      });
    },

    initMarker() {
      this.pointList.forEach(point => {
        const { lnglat, title } = point;
        const marker = new google.maps.Marker({
          position: { lat: lnglat[1], lng: lnglat[0] },
          map: this.map,
          title: title
        });

        // 为每个标记点添加事件监听器  
        marker.addListener('click', (e) => {
          console.log('点击了标记点：', e);
          this.point = point;
          this.outerVisible = true;
        });
      });
    },

    closeDialog(isConfirm, program) {
      if (isConfirm) {
        this.point.playInfo = program;
      }
      this.innerVisible = false;
    },

    closePointName(isConfirm) {
      if (isConfirm) {
        if (!this.pointName) {
          this.$msg({ message: this.$t("nstm67"), type: "warning", showClose: true });
          return;
        }
        let list = this.pointList.map((point) => {
          const { radius, lnglat: [lng, lat], playInfo: { id, name }, title } = point;
          return {
            group_id: this.$cookies.get("group_id"),
            name: this.pointName,
            point: title,
            lng, lat,
            radius,
            play_id: id,
            play_name: name,
          }
        });

        this.$http.post('/admin/device/setPoint', {
          point: encodeURIComponent(JSON.stringify(list)),
        }, () => {
          this.$router.go(-1);
        })
      }
      this.dialogVisible = false;
    },

    setRadiusSize(val) {
      this.point.radius = val;
    },

    addPointSet(Bool) {
      if (Bool) {
        if (!(this.point.radius && this.point.playInfo)) {
          this.$msg({
            message: this.$t('nstm68'),
            type: "warning",
            showClose: true
          });
          return;
        }
        this.pointList.push(this.point);
        this.initMarker();
      }
      this.outerVisible = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.point-set {

  // .play {}
  div {
    margin: 8px 0px;
  }
}

/deep/ .el-dialog {
  margin: 0px;
  border-radius: 8px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/deep/ .el-dialog__header {
  padding: 16px;
  border-radius: 8px 8px 0px 0px;
  // background-image: linear-gradient(270deg,
  //     #86eae7 0%,
  //     #4cccf0 45%,
  //     #11adf8 100%),
  //   linear-gradient(#ffffff, #ffffff);
  // background-blend-mode: normal, normal;
  background-color: var(--theme-color-customized-1);

  .el-dialog__title {
    font-size: 20px;
    color: #fff;
  }
}

/deep/ .el-dialog__body {
  padding: 16px;
  overflow: hidden;
}

/deep/ .el-dialog__footer {
  padding: 0px 16px 16px;
  border-radius: 0px 0px 8px 8px;

  /deep/ .el-button+.el-button {
    margin-left: 20px;
  }
}
</style>